/* Included for testing as the GeolocationPositionError is unavailable in jest */
export var GeolocationPositionErrorCode;
(function (GeolocationPositionErrorCode) {
    GeolocationPositionErrorCode[GeolocationPositionErrorCode["PERMISSION_DENIED"] = 1] = "PERMISSION_DENIED";
    GeolocationPositionErrorCode[GeolocationPositionErrorCode["POSITION_UNAVAILABLE"] = 2] = "POSITION_UNAVAILABLE";
    GeolocationPositionErrorCode[GeolocationPositionErrorCode["TIMEOUT"] = 3] = "TIMEOUT";
})(GeolocationPositionErrorCode || (GeolocationPositionErrorCode = {}));
var AppHostLocationService = /** @class */ (function () {
    function AppHostLocationService() {
    }
    AppHostLocationService.prototype.getCurrentLocation = function () {
        return new Promise(function (resolve, reject) {
            if (window.navigator.geolocation) {
                window.navigator.geolocation.getCurrentPosition(function (position) {
                    return resolve({
                        accuracy: position.coords.accuracy,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        timestamp: position.timestamp,
                    });
                }, function (positionError) {
                    return reject(GeolocationPositionErrorCode[positionError.code]);
                });
            }
            else
                reject(GeolocationPositionErrorCode.POSITION_UNAVAILABLE);
        });
    };
    AppHostLocationService.prototype.withLocationMapService = function (service) {
        this.mapService = service;
        return this;
    };
    return AppHostLocationService;
}());
export { AppHostLocationService };
//# sourceMappingURL=AppHostLocationService.js.map